import React, { useState } from 'react';
import { X, User, Phone, Send } from 'lucide-react';

const BookingModal = ({ isOpen, onClose, pageTitle = "Consultation" }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    const web3FormsData = {
      access_key: '1f175609-bc95-44f0-8131-bf189a5c01ac',
      ...formData,
      subject: `Consultation Request - ${pageTitle} - ${formData.name}`
    };

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(web3FormsData)
      });

      const result = await response.json();

      if (result.success) {
        setStatus('success');
        setFormData({ name: '', phone: '' });
        setTimeout(() => {
          setStatus('');
          onClose();
        }, 2000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setStatus('error');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <X size={24} />
        </button>
        
        <div className="modal-header">
          <h2>Book Your Consultation</h2>
          <p>We'll contact you shortly to confirm your appointment</p>
        </div>

        <form onSubmit={handleSubmit} className="booking-form">
          <div className="form-group">
            <label htmlFor="name">
              <User size={18} />
              Full Name *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">
              <Phone size={18} />
              Phone Number *
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Enter your phone number"
              pattern="[0-9]{10}"
              title="Please enter a 10-digit phone number"
            />
          </div>

          <button type="submit" className="modal-submit-button" disabled={status === 'sending'}>
            {status === 'sending' ? (
              'Sending...'
            ) : (
              <>
                <Send size={18} />
                Book Consultation
              </>
            )}
          </button>

          {status === 'success' && (
            <div className="form-message success">
              Thank you! We'll contact you soon.
            </div>
          )}

          {status === 'error' && (
            <div className="form-message error">
              Something went wrong. Please try again or call us directly.
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default BookingModal;
